<template>
  <div>
    <modal
    id="p-game-future-modal"
    class="p-game-future-modal-wrapper"
    size="800px"
    :show.sync="show"
    :footer="false"
    >

    <div class="row w-100 mb-3 ">
      <h3 class="p-game-future-modal-title">آدرس محل : </h3>
      <h3 class="mr-1 p-game-future-modal-title-detail">{{detailMap.location}}</h3>
    </div>

    <div class="w-100  p-map-salon-map-main">
      <l-map
          :zoom="zoom"
          :center="center"
          :options="mapOptions"
          @update:center="centerUpdate"
          @update:zoom="zoomUpdate($event)"
          @click="addMarker"
          >
          <l-tile-layer
          :url="url"
          />

          <l-marker
          v-for="data in markers" :key="data.id"
          :lat-lng="data.position"
          :icon="data.icon"
          >

        </l-marker>

      </l-map>

    </div>


<!-- <div class="p-wallet-player-modal-wrapper row w-100 flex-column justify-content-center">
<div class="w-100 d-flex justify-content-center mb-3">
<h3 class="p-wallet-player-modal-title">توضیحات جام</h3>
</div>
<div class="w-100 d-flex justify-content-center mb-4">
<p class="p-wallet-player-modal-content">{{detailMap.content}}</p>
</div>

<div class="w-100 d-flex justify-content-center ">
<button @click="closeModal" type="button" class="btn btn-primary btn-blue btn-sm btn-table align-items-center d-flex justify-content-center p-wallet-player-modal-close">
بستن
<svg class="p-wallet-player-modal-close" fill="#fff"  enable-background="new 0 0 413.348 413.348" height="512" viewBox="0 0 413.348 413.348" width="512" xmlns="http://www.w3.org/2000/svg"><path d="m413.348 24.354-24.354-24.354-182.32 182.32-182.32-182.32-24.354 24.354 182.32 182.32-182.32 182.32 24.354 24.354 182.32-182.32 182.32 182.32 24.354-24.354-182.32-182.32z"/></svg>
</button>
</div>
</div> -->

</modal>
</div>
</template>

<script>
import { latLng,icon,L,map  } from "leaflet";


export default {
  name: 'modalMap',
  props: {
    active       : { type: [Boolean, Number], default: false },
    detailMap    : { type: [Array, Object], default: {} },
  },

  data() {
    return {
      zoom: 18,
      center: latLng(30.2791476,57.0745852),
      url: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
      withPopup: latLng(30.2791476,57.0745852),
      currentZoom: 11.5,
      showParagraph: false,
      mapOptions: {
        zoomSnap    : 0.5,
      },
      // icon: icon({
      //   // iconUrl: "../img/icons/pin.png",
      //   iconUrl: "../../img/icons/pin.png",
      //   iconSize: [42 ,42],
      //   iconAnchor: [16, 37]
      // }),
      markers: [
      ],
    }
  },

  computed: {
    show: {
      set(val) {
        this.$emit('update:active', !!val)
      },
      get() {
        return !!this.active
      }
    },
  },

  mounted () {
  },

  watch: {
    detailMap(data){
      this.setIconMarkers();

    }
  },

  methods: {
    closeModal(){
      this.show = false;
    },

    zoomUpdate(zoom) {
      this.currentZoom = zoom;
    },

    centerUpdate(center) {
      this.currentCenter = center;
    },

    addMarker(data) {
      const currentPlaceLatlng    = data.latlng;
      const findCurrentParent     = data.originalEvent.target.parentNode.className;
      const lat                   = currentPlaceLatlng.lat;
      const lng                   = currentPlaceLatlng.lng;
      // this.markers[0].position    =  latLng(lat,lng );

      const NewlatLng = {
        lat : lat,
        lng : lng,
      }

      this.$emit('latLngCallBack',NewlatLng)
    },

    setIconMarkers(){
      this.markers         = [];
      const latLngCurrent  = this.detailMap.point.coordinates;

      const myMarkerIconPin = icon({
        iconUrl: require('../../assets/svg/pin.png'),
        iconSize: [42 ,42],
      });

      const newMarker =  {
        id: 2,
        position: latLng(latLngCurrent[1],latLngCurrent[0]),
        visible: true,
        icon: myMarkerIconPin,
        title : this.detailMap.location,
      }

      this.markers = [...this.markers,newMarker];
      this.center  = latLng(latLngCurrent[1],latLngCurrent[0])



      // this.locationData.locations.map((t,i)=>{
      //
      //   if (typeof(t.position) != 'undefined') {
      //       t.lat = t.position.coordinates[1];
      //       t.lng = t.position.coordinates[0];
      //
      //      newMarker =  {
      //       id: t.id,
      //       position: latLng(t.position.coordinates[1],t.position.coordinates[0]),
      //       visible: true,
      //       icon: myMarkerIconPin,
      //       title : t.title,
      //     }
      //   }
      //   else {
      //       newMarker =  {
      //        id: t.id,
      //        position: latLng(t.lat,t.lng),
      //        visible: true,
      //        icon: myMarkerIconPin,
      //        title : t.title,
      //      }
      //   }
      //
      //     this.markers = [...this.markers,newMarker]
      // })

    }

  },

}
</script>
